import * as GeneralRepository from "./general-repository";
import * as BeneficiarioProvider from "../providers/beneficiario-provider";
import * as BeneficiarioMapper from "../mappers/beneficiario-mapper";

export const obtenerBeneficiarios = async (idSolicitudMultiple) => {
    const response = await BeneficiarioProvider.obtenerBeneficiarios(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            beneficiarios: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerBeneficiarios(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    beneficiarios: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                beneficiarios: null
            }
        }
    }
}

export const eliminarBeneficiario = async (idSolicitud, idBeneficiario, flag) => {
    const response = await BeneficiarioProvider.eliminarBeneficiario(idSolicitud, idBeneficiario, flag)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            beneficiario: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await eliminarBeneficiario(idSolicitud, idBeneficiario, flag)
            } else {
                return {
                    error: response.auditResponse,
                    beneficiario: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                beneficiario: null
            }
        }
    }
}

export const guardarBeneficiario = async (idSolicitud, beneficiario, usuario) => {
    let request = BeneficiarioMapper.mapBeneficiarioToRequest(idSolicitud, beneficiario, usuario)
    let response = null
    if(beneficiario.idBeneficiario !== undefined && beneficiario.idBeneficiario !== null && beneficiario.idBeneficiario !== 0) {
        response = await BeneficiarioProvider.actualizarBeneficiario(idSolicitud, request)
    } else {
        response = await BeneficiarioProvider.registrarBeneficiario(idSolicitud, request)
    }

    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            beneficiario: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await guardarBeneficiario(idSolicitud, beneficiario, usuario)
            } else {
                return {
                    error: response.auditResponse,
                    beneficiario: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                beneficiario: null
            }
        }
    }
}